import React from "react";
import { ContentSection, GridColumn } from "sprint-common-web";

import { FileRecordBuzzView } from "../../../../../common/file-record-details/buzz/FileRecordBuzzView";
import {
    FileRecordDetails,
    isSubtitleFileRecordDetails
} from "../../../../../common/file-record-details/FileRecordDetails";

interface FileRecordBuzzSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const FileRecordBuzzSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: FileRecordBuzzSectionProps): JSX.Element => {
    return (
        <GridColumn sm={isSubtitleFileRecordDetails(fileRecordDetails) ? 12 : 4}>
            <ContentSection
                header="File record Buzz"
                testId="buzz-content-section"
                isLoading={isFileRecordDetailsLoading}
                style={{ height: 300 }}
            >
                <FileRecordBuzzView fileRecordDetails={fileRecordDetails} />
            </ContentSection>
        </GridColumn>
    );
};
